export default {
    home: "{organisation} logo - link to home",
}